import { app } from '../../app.module'
app
  // Instagramアカウントテーブルの平均値
  .directive('accountInstagramTableAverage', () => {
    return {
      restrict: 'EA',
      template: require('./account-instagram-table-average.pug')(),
      controller: function ($scope) {
        $scope.$watch(
          () => {
            return $scope.sortAccounts
          },
          () => {
            let followersTotal = 0
            let followersPerPostTotal = 0
            let likesTotal = 0
            let likesPerPostTotal = 0
            let commentsTotal = 0
            let commentsPerPostTotal = 0
            let engagementsTotal = 0
            let engagementsPerPostTotal = 0
            let engagementRateTotal = 0
            let postCountTotal = 0

            $scope.sortAccounts.forEach(function (account) {
              followersTotal = followersTotal + account.followers
              likesTotal = likesTotal + account.likes
              commentsTotal = commentsTotal + account.comments
              engagementsTotal = engagementsTotal + account.engagements
              engagementRateTotal = engagementRateTotal + account.engagementRate
              postCountTotal = postCountTotal + account.posts
              // 投稿数が0より大きい場合、1投稿あたりの平均を会計
              if (account.posts > 0) {
                followersPerPostTotal = followersPerPostTotal + account.followers / account.posts
                likesPerPostTotal = likesPerPostTotal + account.likes / account.posts
                commentsPerPostTotal = commentsPerPostTotal + account.comments / account.posts
                engagementsPerPostTotal =
                  engagementsPerPostTotal + account.engagements / account.posts
              } else {
                followersPerPostTotal = followersPerPostTotal + account.followers
                likesPerPostTotal = likesPerPostTotal + account.likes
                commentsPerPostTotal = commentsPerPostTotal + account.comments
                engagementsPerPostTotal = engagementsPerPostTotal + account.engagements
              }
            })

            // 平均値
            $scope.followersAverage = followersTotal / $scope.sortAccounts.length
            $scope.likesAverage = likesTotal / $scope.sortAccounts.length
            $scope.commentsAverage = commentsTotal / $scope.sortAccounts.length
            $scope.engagementsAverage = engagementsTotal / $scope.sortAccounts.length
            $scope.engagementRateAverage = engagementRateTotal / $scope.sortAccounts.length
            $scope.postsAverage = postCountTotal / $scope.sortAccounts.length

            // 1投稿あたりの平均値
            $scope.likesPerPostAverage = likesPerPostTotal / $scope.sortAccounts.length
            $scope.commentsPerPostAverage = commentsPerPostTotal / $scope.sortAccounts.length
            $scope.engagementsPerPostAverage = engagementsPerPostTotal / $scope.sortAccounts.length
          }
        )
      },
    }
  })
